import { Utensils, Coffee, IceCream, Pizza, Soup, Fish, Salad, Wine } from 'lucide-react';

// Translations
export const translations = {
  en: {
    title: 'BENZ POS',
    subtitle: 'Order Management System',
    incomingOrders: 'Incoming Orders',
    activeTables: 'Active Tables',
    newOrder: 'New Order',
    noOrders: 'No pending orders',
    noOrdersDesc: 'New customer orders will appear here',
    noTables: 'No active tables',
    noTablesDesc: 'Tables with orders will appear here',
    table: 'Table',
    orders: 'orders',
    items: 'items',
    total: 'Total',
    subtotal: 'Subtotal',
    discount: 'Discount',
    cardFee: 'Card Fee',
    sendToKitchen: 'Send to Kitchen',
    sendToBar: 'Send to Bar',
    sendAll: 'Send All',
    viewDetails: 'View Details',
    printTicket: 'Print Ticket',
    printBill: 'Print Bill',
    closeBill: 'Close & Print Bill',
    pending: 'Pending',
    preparing: 'Preparing',
    ready: 'Ready',
    served: 'Served',
    newItems: 'New Items',
    previousOrders: 'Previous Orders',
    addItems: 'Add Items',
    checkout: 'Checkout',
    confirmPayment: 'Confirm Payment',
    paymentMethod: 'Payment Method',
    cash: 'Cash',
    card: 'Card',
    orderSent: 'Order Sent!',
    orderComplete: 'Order Complete',
    backToTables: 'Back to Tables',
    addMoreItems: 'Add More Items',
    searchMenu: 'Search menu...',
    allCategories: 'All',
    tableNumber: 'Table Number',
    openSince: 'Open since',
    minutesAgo: 'min ago',
    kitchen: 'Kitchen',
    bar: 'Bar',
    billing: 'Billing',
    admin: 'Admin',
    menu: 'Menu',
    settings: 'Settings',
    logout: 'Logout',
    soundOn: 'Sound On',
    soundOff: 'Sound Off',
    refresh: 'Refresh',
    language: 'Language',
    cancel: 'Cancel',
    confirm: 'Confirm',
    close: 'Close',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    foodItems: 'Food Items',
    drinkItems: 'Drink Items',
    transferToKitchen: 'Transfer to Kitchen',
    transferToBar: 'Transfer to Bar',
    markReady: 'Mark Ready',
    markServed: 'Mark Served',
    markPaid: 'Mark Paid',
    orderHistory: 'Order History',
    sessionTotal: 'Session Total',
    quickTables: 'Quick Tables',
    customTable: 'Custom',
    empty: 'Empty',
    active: 'Active',
    paid: 'Paid',
    unpaid: 'Unpaid',
    allOrders: 'All Orders',
    pendingApproval: 'Pending Approval',
    transferred: 'Transferred',
    cooking: 'Cooking',
    drinks: 'Drinks',
    food: 'Food',
    cancelOrder: 'Cancel Order',
    orderStatus: 'Order Status',
    splitBill: 'Split Bill',
    splitBillTitle: 'Split Bill',
    splitEvenly: 'Split Evenly',
    splitEvenlyDesc: 'Divide total equally',
    howManyPeople: 'How many people?',
    person: 'Person',
    addPerson: 'Add Person',
    removePerson: 'Remove',
    assignItems: 'Tap items to assign',
    unassigned: 'Unassigned Items',
    confirmSplit: 'Confirm & Close',
    splitSummary: 'Split Summary',
    printAll: 'Print All Bills'
  },
  vi: {
    title: 'BENZ POS',
    subtitle: 'He thong quan ly don hang',
    incomingOrders: 'Don hang moi',
    activeTables: 'Ban dang phuc vu',
    newOrder: 'Tao don moi',
    noOrders: 'Khong co don cho',
    noOrdersDesc: 'Don hang tu khach se hien o day',
    noTables: 'Khong co ban hoat dong',
    noTablesDesc: 'Ban co don se hien o day',
    table: 'Ban',
    orders: 'don',
    items: 'mon',
    total: 'Tong',
    subtotal: 'Tam tinh',
    discount: 'Giam gia',
    cardFee: 'Phi the',
    sendToKitchen: 'Gui Bep',
    sendToBar: 'Gui Bar',
    sendAll: 'Gui tat ca',
    viewDetails: 'Xem chi tiet',
    printTicket: 'In phieu',
    printBill: 'In hoa don',
    closeBill: 'Thanh toan & In',
    pending: 'Cho xu ly',
    preparing: 'Dang lam',
    ready: 'San sang',
    served: 'Da phuc vu',
    newItems: 'Mon moi',
    previousOrders: 'Don truoc',
    addItems: 'Them mon',
    checkout: 'Thanh toan',
    confirmPayment: 'Xac nhan thanh toan',
    paymentMethod: 'Phuong thuc',
    cash: 'Tien mat',
    card: 'The',
    orderSent: 'Da gui don!',
    orderComplete: 'Hoan thanh',
    backToTables: 'Quay lai',
    addMoreItems: 'Them mon',
    searchMenu: 'Tim mon...',
    allCategories: 'Tat ca',
    tableNumber: 'So ban',
    openSince: 'Mo tu',
    minutesAgo: 'phut truoc',
    kitchen: 'Bep',
    bar: 'Bar',
    billing: 'Hoa don',
    admin: 'Quan tri',
    menu: 'Thuc don',
    settings: 'Cai dat',
    logout: 'Dang xuat',
    soundOn: 'Bat am thanh',
    soundOff: 'Tat am thanh',
    refresh: 'Lam moi',
    language: 'Ngon ngu',
    cancel: 'Huy',
    confirm: 'Xac nhan',
    close: 'Dong',
    save: 'Luu',
    delete: 'Xoa',
    edit: 'Sua',
    foodItems: 'Mon an',
    drinkItems: 'Do uong',
    transferToKitchen: 'Chuyen Bep',
    transferToBar: 'Chuyen Bar',
    markReady: 'San sang',
    markServed: 'Da phuc vu',
    markPaid: 'Da thanh toan',
    orderHistory: 'Lich su don',
    sessionTotal: 'Tong phien',
    quickTables: 'Chon nhanh',
    customTable: 'Tuy chinh',
    empty: 'Trong',
    active: 'Dang dung',
    paid: 'Da TT',
    unpaid: 'Chua TT',
    allOrders: 'Tat ca don',
    pendingApproval: 'Cho duyet',
    transferred: 'Da chuyen',
    cooking: 'Dang nau',
    drinks: 'Do uong',
    food: 'Mon an',
    cancelOrder: 'Huy don',
    orderStatus: 'Trang thai',
    splitBill: 'Chia bill',
    splitBillTitle: 'Chia hoa don',
    splitEvenly: 'Chia deu',
    splitEvenlyDesc: 'Chia deu tong tien',
    howManyPeople: 'Bao nhieu nguoi?',
    person: 'Nguoi',
    addPerson: 'Them nguoi',
    removePerson: 'Xoa',
    assignItems: 'Chon mon de gan',
    unassigned: 'Chua gan',
    confirmSplit: 'Xac nhan & Dong',
    splitSummary: 'Tong ket chia bill',
    printAll: 'In tat ca'
  }
};

// Beverage categories
export const BEVERAGE_CATEGORIES = ["Smoothies", "Juice", "Cocktails", "Long Drinks", "Beer", "Soft Drinks", "Wine", "Hard Liquor", "Coffee"];

// Category icons
export const getCategoryIcon = (category) => {
  const icons = {
    'Appetizers': <Utensils size={16} />,
    'Salads': <Salad size={16} />,
    'Soups': <Soup size={16} />,
    'Pho': <Soup size={16} />,
    'Seafood': <Fish size={16} />,
    'Main Dishes': <Pizza size={16} />,
    'Fish': <Fish size={16} />,
    'Pasta': <Pizza size={16} />,
    'Noodles': <Soup size={16} />,
    'Rice': <Pizza size={16} />,
    'Smoothies': <Coffee size={16} />,
    'Juice': <Coffee size={16} />,
    'Cocktails': <Wine size={16} />,
    'Beer': <Wine size={16} />,
    'Wine': <Wine size={16} />,
    'Coffee': <Coffee size={16} />,
    'Dessert': <IceCream size={16} />,
  };
  return icons[category] || <Utensils size={16} />;
};

// Get elapsed time
export const getElapsedTime = (createdAt) => {
  const diff = Math.floor((new Date() - new Date(createdAt)) / 1000 / 60);
  if (diff < 60) return `${diff}m`;
  return `${Math.floor(diff / 60)}h ${diff % 60}m`;
};
